// extracted by mini-css-extract-plugin
export default {"gameLogPane":"styles_gameLogPane__fMTTR"};